export const EXTERNAL_REDIRECT_BY_PATH: Record<string, string> = {
  lukasz: "https://card.gsignature.com/81y6E39RyquB",
};
